import React from 'react';
import AbsoluteFooter from '../../components/Footer/AbsoluteFooter';
import { useStateContext } from '../../context/ContextProvider';

const EventThankYou = ({
    language
}) => {

    return (
        <div className="bg-[#00112D] min-h-screen flex flex-col items-center justify-center w-full gap-6 padding-container !py-12">
            <div className="custom-card p-6 flex flex-col justify-center items-center gap-4 text-center">
                <img src="/assets/images/projects/event/libya/done.gif" alt="DoDeal Properties" className="w-[100px]" />
                {language == "ar" ? (
                    <>
                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center">
                            شكراً
                            <span className={`primary-text`}>
                                لتسجيلك !!
                            </span>
                        </h1>
                        <p className="text-[#D0D0D0] text-center">
                            فى انتظارك فى … يوم ...
                        </p>
                        <div className="flex justify-center p-5">
                            <a
                                href="/event/libya"
                                className={`custom-btn w-fit min-w-[160px] font-medium border border-1 primary-bg text-white  border-[var(--primary)]`}
                            >
                                برنامج المؤتمر
                            </a>
                        </div>
                    </>
                ) : (
                    <>
                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                            Thank You for
                            <span className={`primary-text`}>
                                registering!!
                            </span>
                        </h1>
                        <p className="text-[#D0D0D0] text-center capitalize">
                            Waiting for you on the day.
                        </p>

                        <div className="flex justify-center p-5">
                            <a
                                href="/event/libya"
                                className={`custom-btn w-fit min-w-[160px] font-medium border border-1 primary-bg text-white  border-[var(--primary)]`}
                            >
                                Conference Programme
                            </a>
                        </div>
                    </>
                )}
            </div>
            <AbsoluteFooter />
        </div>
    );
}

export default EventThankYou;
